import { motionValue } from 'framer-motion';

/**
 * Shared motion communication layer
 * Synchronizes orbital motion values globally
 */
export const orbScrollProgress = motionValue(0);
export const orbCenterBlend = motionValue(0);
export const orbVisibility = motionValue(1);
